export class HTTPRequestError extends Error {
	constructor (msg?: string) {
		super(msg);
		this.name = this.constructor.name;
	}
}

export interface WrappedResponse<T> {
	responsePayload: T
}